import { Component, OnInit } from '@angular/core';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { ProductoService } from 'src/app/services/producto.service';
import {FormBuilder, FormGroup, Validators, NgForm} from "@angular/forms";
import {Router} from "@angular/router";
import Swal from 'sweetalert2';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-registro',
  templateUrl: './registro.component.html',
  styleUrls: ['./registro.component.scss']
})
export class RegistroComponent implements OnInit {
  
  baseUrl = environment.apiUrl;

  convenios: any[] = [];
  errorMessage: string;
  tipo: string;

  registroForm: FormGroup;
  submitted = false;
  finalizar = false;
  error_correo = false;

  constructor(
      private fb: FormBuilder, 
      private router: Router, 
      private http: HttpClient, 
      private productoService: ProductoService
      ) { 

      this.http.get(this.baseUrl+'api/verconvenios')
      .subscribe( (resp:any) => {
      this.convenios = resp;
      console.log(resp);
      });
      
      }

  ngOnInit() {
    this.nuevoRegistro();
  }

  GuardarSexo(sexo:string){
    this.tipo = sexo;
    this.registroForm.controls['sexo'].setValue(sexo);
  }

  nuevoRegistro() {
    this.registroForm = this.fb.group({
      nombre: ['', Validators.required],
      a_paterno: ['', Validators.required],
      a_materno: [''],
      fecha_nac: ['', Validators.required],
      sexo: [''],
      telefono: ['', [
        Validators.required, 
        Validators.pattern("^[0-9]*$"),
        Validators.minLength(10), 
        Validators.maxLength(10)
      ]],
      email: ['', [Validators.required, Validators.email]],
      password: ['', [
        Validators.required,
        Validators.minLength(6)
      ]],
    });
  }

  // convenience getter for easy access to form fields
  get f() { return this.registroForm.controls; }

  onSubmit() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.registroForm.invalid) {
      return;
    }

    Swal.fire({
      allowOutsideClick: false,
      html:'<strong>Procesando la información...</strong>',
    });
    Swal.showLoading();

    this.productoService.postRegistro(this.registroForm.value)
    .subscribe( data => {
      
      Swal.close();
      
      if(data['resultado'] === "error email"){
        Swal.fire(
          'El correo ya ha sido registrado',
          'Puedes recuperar la contraseña o intentar con un correo diferente',
          'warning'
        )
      }else{
        this.finalizar = true;
      }
    },
      error => {
          this.errorMessage = error
      }
    );
    // console.log('registroForm' , this.registroForm.value);
  }

}
